import routesPath from '@/utils/routesPath'
import Cookies from 'js-cookie'
import { Navigate, Outlet } from 'react-router-dom'

const { DASHBOARD } = routesPath

const IsGuestUser = () => {
  const accessToken = Cookies.get('token')

  if (accessToken) {
    // not logged in so redirect to login page with the return url
    return <Navigate to={DASHBOARD} />
  }

  return <Outlet />
}

export default IsGuestUser
